import Agent from '../api/Agent'
import { configureStore } from '../redux/store'
import ReactGA from 'react-ga'

export const configureApp = (apiurl, debug) => {
	ReactGA.initialize('UA-81900570-5')
	Agent.init(apiurl)
	return configureStore(debug)
}
